import { request } from '@@/plugin-request';

export async function queryCurrent() {
  return request('/api/currentUser');
}
export async function queryFakeList(params) {
  return request('/api/fake_list', {
    params,
  });
}

export async function querySubmissions(params) {
  return request('/api/submissions', {
    params,
  });
}
